import React from "react";
import { Button, type ButtonProps } from "antd";

export interface LinkButtonProps extends ButtonProps {
  /** 是否去除默认内边距 */
  removePadding?: boolean;
}

type DocgenInfo = {
  displayName: string;
  description: string;
  props: Record<string, {
    name: string;
    required: boolean;
    description: string;
    type: { name: string; raw: string };
    defaultValue?: { value: string };
  }>;
};

type ComponentWithDocgen = React.FC<LinkButtonProps> & { __docgenInfo?: DocgenInfo };

/** 链接样式按钮组件，适用于表格操作列 */
export const LinkButton: React.FC<LinkButtonProps> = ({ 
  removePadding = true,
  className,
  ...props 
}) => {
  const linkClassName = removePadding 
    ? `px-0 h-auto ${className || ''}` 
    : className;

  return (
    <Button 
      type="link" 
      {...props} 
      className={linkClassName}
    >
      {props.children}
    </Button>
  );
};

// 手动添加 docgen 信息
(LinkButton as ComponentWithDocgen).__docgenInfo = {
  displayName: "LinkButton",
  description: "链接样式按钮组件，适用于表格操作列",
  props: {
    removePadding: {
      name: "removePadding",
      required: false,
      description: "是否去除默认内边距",
      type: { name: "boolean", raw: "boolean" },
      defaultValue: { value: "true" }
    },
    children: {
      name: "children",
      required: false,
      description: "按钮内容",
      type: { name: "ReactNode", raw: "React.ReactNode" }
    },
    onClick: {
      name: "onClick",
      required: false,
      description: "点击事件",
      type: { name: "function", raw: "(event: React.MouseEvent<HTMLButtonElement>) => void" }
    },
    disabled: {
      name: "disabled",
      required: false,
      description: "是否禁用",
      type: { name: "boolean", raw: "boolean" }
    },
    className: {
      name: "className",
      required: false,
      description: "自定义类名",
      type: { name: "string", raw: "string" }
    }
  }
};
